import styled from 'styled-components';
import { Modal, ModalBody } from 'reactstrap';

export const ModalContainer = styled(Modal)`
  box-shadow: 0 5px 15px rgb(0 0 0 / 50%);
  margin-top: 70px !important;
  font-family: 'Open Sans', sans-serif;
`;

export const ModalTitle = styled.label`
  color: #295c88;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.7px;
`;

export const ModalContent = styled.div`
  max-height: calc(100vh - 230px);
  overflow-y: auto;
  font-size: 14px;
  color: #373a3c;
  font-weight: 400;
  width: 100%;
`;

export const ModalBodyContainer = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
`;

export const ModalFooterSpacer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 5px;
`;

export const ModalTextArea = styled.textarea`
  width: 100%;
`;

export const CancelButton = styled.button`
  border: 0;
  background: white;
  line-height: 6px;
  color: #505050;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
`;

export const FeedbackModalBody = styled.div`
  max-height: 500px;
  overflow: auto;
  padding: 20px;

  img {
    width: 100%;
  }
`;

export const LabelHeading = styled.span`
  font-weight: 600;
`;
